import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import moment from "moment";

const AuditLog = (props) => {
  const [data, setData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [moduleData, setModuleData] = useState([]);
  const [serviceId, setServiceId] = useState(0);
  const [moduleId, setModuleId] = useState(0);

  const { sendRequest: getAuditLog } = useHttp();

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const getLogs = () => {
    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    var tdate = moment(selectedToDate).format("DD/MM/YYYY");
    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (serviceId > 0) {
      urlfilter = urlfilter + `&serviceId=${serviceId}`;
    }

    if (moduleId > 0) {
      urlfilter = urlfilter + `&moduleId=${moduleId}`;
    }

    var url = `/api/auditLog/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getAuditLog(
      {
        url: url,
      },
      (res) => {
        const sortedData = res.sort((a, b) => b.auditLogId - a.auditLogId);
       // console.log(res);
        setData(sortedData);
      }
    );
  };

  useEffect(() => {
    getLogs(0,0);
  }, [getAuditLog]);

  const { sendRequest: getModules } = useHttp();

  useEffect(() => {
    getModules(
      {
        url: `/api/moduleMaster/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
      //  console.log(data);
        setModuleData(data);
      }
    );
  }, [getModules]);

  const { sendRequest: getServices } = useHttp();
  useEffect(() => {
    getServices(
      {
        url: `/api/serviceMaster/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
      //  console.log(res);
        const filterdData=res&&res.filter((itm)=>itm.moduleId==moduleId);
        //console.log(filterdData);

       setServiceData(filterdData);
      }
    );
  }, [moduleId]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Audit Log</label>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row ">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-group">
                          {" "}
                          <label htmlFor={"from_date"}>{"From Date"}</label>
                          <input
                            type={"date"}
                            id={"date"}
                            required
                            className="form-control"
                            max={currentDate}
                            value={selectedFromDate}
                            onChange={handleFDateChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label>{"To Date"}</label>

                          <input
                            type={"date"}
                            id={"date"}
                            required
                            className="form-control"
                            max={currentDate}
                            value={selectedToDate}
                            onChange={handleTDateChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor={"moduleName"}>{"Module Name"}</label>
                          <select
                            id="moduleName"
                            className="form-control"
                            value={moduleId}
                            onChange={(e) => {
                              setModuleId(e.target.value);
                            }}
                          >
                            <option value="0">select</option>
                            {moduleData &&
                              moduleData.map((x) => (
                                <option key={x.moduleId} value={x.moduleId}>
                                  {x.moduleName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Service Name</label>
                          <select
                            id="serviceName"
                            className="form-control"
                            value={serviceId}
                            onChange={(e) => {
                              setServiceId(e.target.value);
                            }}
                          >
                            <option value="0">select</option>
                            {serviceData &&
                              serviceData.map((x) => (
                                <option key={x.serviceId} value={x.serviceId}>
                                  {x.serviceName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    

                      <div className="col-md-2">
                        <div className="form-group">
                          <label>&nbsp;</label>
                          <button
                            className="form-control btn btn-sm btn-primary"
                            onClick={(e) => {
                              getLogs(serviceId, moduleId);
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Doc No</th>
                          <th>Employee Name</th>
                          <th>Operation</th>
                          
                          <th>Service Name</th>
                          <th>Module Name</th>
                          <th>Operation Message</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.operationDate}</td>
                                <td>{itm.doc}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.operationType}</td>
                                
                                <td>{itm.serviceName}</td>
                                <td>{itm.moduleName}</td>
                                <td>{itm.operationDetail}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AuditLog;
